import React from "react";

export const DeleteConfirmationPopup = ({
  show,
  onClose,
  onConfirm,
  sessionDate
}) => {
  if (!show) return null;

  return (
    <div
      className="modal fade show"
      style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
      tabIndex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-modal="true"
      role="dialog"
    >
      <div className="modal-dialog confirmation-modal-width">
        <div className="modal-content">
          <div className="modal-header border-0">
            <button
              type="button"
              className="btn-close font-12"
              onClick={onClose}
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            <div className="d-flex flex-column align-items-center justify-content-center">
              <img
                src="/Images/cancel-popup-icon.svg"
                alt="cancel-icon"
                className="mb-3"
              />
              <p className="font-14 medium-text text-center">
                Are you sure you want to cancel{" "}
                <span className="bold-text">“{sessionDate}”</span> session?
              </p>
            </div>
          </div>
          <div className="modal-footer border-0">
            <div className="col-md-12 d-flex justify-content-center">
              <button
                className="btn hive-btn-secondary me-3"
                onClick={onClose}
              >
                No
              </button>
              <button className="btn hive-negative-btn" onClick={onConfirm}>
                Yes
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Simple backdrop */}
      <div
        className="fade show"
        style={{ zIndex: 1040 }}
        onClick={onClose}
      ></div>
    </div>
  );
};
